import { MediaAssetImageProps } from "design-system/components/primitives/media-asset/media-asset-image";
import {
  LegacySearchHit,
  ModernSearchHit,
  SearchDisplay,
  SearchHit,
} from "frontend/types";
import { BookTeaseProps } from "design-system/components/primitives/book-tease/book-tease";
import { isSearchHitType } from "./is-search-hit-type";

export function createSearchBookTease(
  data?: SearchHit,
  thumbnailProps?: Partial<MediaAssetImageProps>,
) {
  if (isSearchHitType<LegacySearchHit>("legacy", data)) {
    return createLegacySearchBookTease(data, thumbnailProps);
  }
  if (isSearchHitType<ModernSearchHit>("modern", data)) {
    return createModernSearchBookTease(data, thumbnailProps);
  }
}

export function createLegacySearchBookTease(
  data: LegacySearchHit,
  thumbnailProps?: Partial<MediaAssetImageProps>,
): BookTeaseProps | undefined {
  const props: BookTeaseProps = {
    type: "Book",
    description: data.HBSDescription,
  };

  if (data.HBSTitle) {
    const colon = data.HBSTitle.indexOf(":");
    if (colon > -1) {
      props.title = data.HBSTitle.substring(0, data.HBSTitle.indexOf(":"));
      props.subtitle = data.HBSTitle.substring(
        data.HBSTitle.indexOf(":") + 1,
        data.HBSTitle.length,
      );
    } else {
      props.title = data.HBSTitle;
    }
  }
  if (data.HBSLink) {
    props.link = data.HBSLink;
  }
  if (data.HBSPubDate) {
    props.date = data.HBSPubDate;
  }

  if (data.HBSByline) {
    let authors = data.HBSByline;
    if (authors.startsWith("by ")) authors = authors.substring(3);
    if (authors.startsWith("By ")) authors = authors.substring(3);
    if (authors.startsWith("by: ")) authors = authors.substring(4);
    if (authors.startsWith("By: ")) authors = authors.substring(4);
    if (authors.startsWith("re ")) authors = authors.substring(3);
    if (authors.startsWith("Re ")) authors = authors.substring(3);
    if (authors.startsWith("re: ")) authors = authors.substring(4);
    if (authors.startsWith("Re: ")) authors = authors.substring(4);
    props.authors = [{ name: authors }];
  }

  if (data.HBSThumbnail) {
    props.media = {
      image: {
        src: data.HBSThumbnail,
        ...thumbnailProps,
      },
    };
  }

  return props;
}

export function createModernSearchBookTease(
  data: ModernSearchHit | SearchDisplay,
  thumbnailProps?: Partial<MediaAssetImageProps>,
): BookTeaseProps {
  const props: BookTeaseProps = {
    type: "Book",
    description: data.description,
  };

  if (data.title) {
    const colon = data.title.indexOf(":");
    if (colon > -1) {
      props.title = data.title.substring(0, data.title.indexOf(":"));
      props.subtitle = data.title.substring(
        data.title.indexOf(":") + 1,
        data.title.length,
      );
    } else {
      props.title = data.title;
    }
  }

  if (data.url) {
    props.link = data.url;
  }

  if (isSearchHitType<SearchDisplay>("modern", data)) {
    props.authors = [];

    if (data.display?.date) {
      props.date = data.display.date;
    }

    if (data.display?.byline) {
      data.display.byline.forEach((byline) => {
        if (byline.label) {
          props.authors?.push({ name: byline.label, link: byline.link });
        }
      });
    }
    if (!data.display?.byline && data.author) {
      data.author.forEach((author) => {
        props.authors?.push({ name: author });
      });
    }

    if (data.display?.thumbnail) {
      const altText =
        data.display.thumbnail.alt === "" ||
        data.display.thumbnail.alt === undefined ||
        data.display.thumbnail.alt === null
          ? data.title
          : data.display.thumbnail.alt;
      props.media = {
        image: {
          src: data.display.thumbnail.src,
          alt: altText,
          ...thumbnailProps,
        },
      };
    }
  }
  return props;
}
